<div class="brands-page">
    <div class="brands-page__header">
        <h1 class="brands-page__title">{{ TEXT.TITLE }}</h1>
        <button
            type="button"
            class="brands-page__brandlist-btn"
            (click)="downloadPreorderBrandlists()"
            [disabled]="downloadingBrandReport"
        >
            <img src="assets/icons/download-icon.svg" alt="" />
            {{ TEXT.DOWNLOAD_PREORDER_BRANDLISTS }}
        </button>
    </div>

    <nav class="brands-page__alphabet" aria-label="Browse by letter">
        <button
            type="button"
            class="brands-page__letter"
            [class.brands-page__letter--active]="selectedLetter === null"
            (click)="selectLetter(null)"
        >
            {{ TEXT.ALL }}
        </button>
        <button
            *ngFor="let letter of alphabet"
            type="button"
            class="brands-page__letter"
            [class.brands-page__letter--active]="selectedLetter === letter"
            [class.brands-page__letter--disabled]="!isLetterAvailable(letter)"
            [disabled]="!isLetterAvailable(letter)"
            (click)="selectLetter(letter)"
        >
            {{ letter }}
        </button>
        <button
            *ngIf="isLetterAvailable(TEXT.OTHER)"
            type="button"
            class="brands-page__letter"
            [class.brands-page__letter--active]="selectedLetter === TEXT.OTHER"
            (click)="selectLetter(TEXT.OTHER)"
        >
            {{ TEXT.OTHER }}
        </button>
    </nav>

    <ng-container *ngIf="loading && letterGroups.length === 0; else brandsLoaded">
        <div class="brands-page__skeleton" aria-busy="true" aria-label="Loading brands">
            <div class="brands-page__skeleton-column" *ngFor="let col of skeletonColumns">
                <div class="brands-page__skeleton-section" *ngFor="let section of col">
                    <div class="brands-page__skeleton-letter"></div>
                    <div class="brands-page__skeleton-row" *ngFor="let row of section"></div>
                </div>
            </div>
        </div>
    </ng-container>

    <ng-template #brandsLoaded>
        <ng-container *ngIf="filteredGroups.length > 0; else emptyState">
            <div class="brands-page__columns">
                <section
                    *ngFor="let group of filteredGroups; trackBy: trackByLetter"
                    class="brands-page__section"
                    [attr.id]="'brand-letter-' + group.letter"
                >
                    <h2 class="brands-page__section-letter">{{ group.letter }}</h2>
                    <ul class="brands-page__list">
                        <li *ngFor="let brand of group.brands; trackBy: trackByBrand">
                            <a
                                class="brands-page__brand"
                                [routerLink]="['/brands', brandSlug(brand.name)]"
                            >
                                {{ brand.name }}
                            </a>
                        </li>
                    </ul>
                </section>
            </div>
        </ng-container>

        <ng-template #emptyState>
            <div class="brands-page__empty">
                <p>{{ TEXT.EMPTY }}</p>
            </div>
        </ng-template>
    </ng-template>
</div>
